<template>
  <div>

    <!-- Data Stores Hack, need to be loaded first -->
    <ShiftStore ref="shiftStore"/>
    <!-- ///////////////////////////////////////// -->

    <h1>Shifts - Data Entry</h1>
    <div>

      <span style="float:left;">Select Date:</span> <DatePicker style="float:left;"/>
    </div>
    <br style="clear:both;" />
    
    
    <!-- Show Data Entry: <input type="checkbox" v-model="ls.showDataEntry" />  -->
    <!-- Show Transaction Counts: <input type="checkbox" v-model="ls.showTransCounts" /> -->
    <!-- Number Of Shifts: <input v-model="ls.numOfShifts" /> -->

    <h4>Intructions</h4>
    
      <p>NetSalesTaxed: Confirm value with the paperwork in the shift. </p>
      <p>NetSalesNonTaxed: Confirm value with the paperwork in the shift.</p>
      <p>Cashier: Enter the cashier's name in the style of Firstname Lastname consistently. Ensure the format is uniform across all entries and avoid any variations such as all caps or lowercase.</p>
      <p>Safe: Enter the sum of the total dollars deposited into the safe, based on the safe slips.</p>
      <p>Coin: Enter the amount of any remaining cash and coin.</p>
      <p>Charges: Enter the sum of Charge Account values.</p>
      <p>Misc Err: Enter any remaining positive or negative errors that cannot be accounted for in other fields. Sum the values, and place the details of these errors in the "Notes" field.</p>
      <p>Notes: Enter any remaining notes or details about the shift, including explanations for values placed in the "Misc Err" field.</p>
    
    <div v-for="location in $locations" :key="location">
      <Shift 
        :location="location" 
        :showDataEntry="true" 
        :showTransCounts="ls.showTransCounts" 
        :numOfShifts="ls.numOfShifts" 
      />
    </div>
  </div>
</template>

<script>
import Shift from '@/pages/Reports/Shifts/Components/Shift.vue'
import DatePicker from '@/pages/Reports/Shifts/Components/DatePicker.vue'
import ShiftStore from '@/pages/Reports/Shifts/Stores/ShiftStore.vue'
import localstorageMixin from '@/mixins/localstorageMixin.js'

export default {
  mixins: [localstorageMixin],
  components : {DatePicker, Shift, ShiftStore},
  name: 'ShiftsPage',
  provide() {
    return {
      shiftsPage: this
    }
  },
  data () { return { 
    ls: {
      day: '2024-08-01',
      showDataEntry: false,
      showTransCounts: false,
      numOfShifts: 10,
    },
    } 
  },

}
</script>